import MembershipDocumentListModelBase from '../_generated/modelBases/membership-document-list-model-base';

export default class MembershipDocumentListModel extends MembershipDocumentListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
